/** Événement */
export default {
  create: 'Création',
  createProgramme: 'Création de programme avec IA',
  aiProgramme: 'programme IA',
  name: 'Nom de l\'événement',
  placeholder: 'Entrez le nom de l\'événement',
  total: 'Total des inscriptions',
  likes: 'Nombre total de likes',
  income: 'Revenu total des inscriptions',
  tips: {
    total: 'Le nombre de candidats n\'inclut pas les annulations',
    income: 'Le revenu n\'inclut pas les remboursements, les récompenses et les ventes de produits'
  },
  table: {
    name: 'Nom de l\'événement',
    status: 'Statut de l\'événement',
    total: 'Total des inscriptions',
    today: 'Inscriptions aujourd\'hui',
    last_week: 'Inscriptions de la semaine dernière',
    create: 'Date de création',
    update: 'Date de mise à jour',
    start: 'Date de début',
    end: 'Date de fin',
    operate: 'Opération',
    oper: {
      data: 'Données d\'inscription',
      config: 'Configuration du contenu',
      progress: 'Configuration de la progression',
      display: 'Affichage de l\'activité',
      screen: 'Écran de données',
      share: 'Partage de l\'événement',
      more: 'Plus de fonctions',
      mores: {
        setting: 'Paramètres d\'affichage',
        ad: 'Paramètres publicitaires',
        live: 'Diffusion en direct d\'images',
        video: 'Points forts vidéo',
        qrcode: 'Code QR de connexion',
        gift: 'Cadeaux et prix'
      }
    },
    total_number: 'Total {total} éléments'
  },
  create_form: {
    placeholder: 'Veuillez saisir',
    status: {
      '是否确认立刻发布活动?': 'Êtes-vous sûr de vouloir publier l\'événement immédiatement ?'
    },
    content: {
      title: 'Contenu de l\'événement',
      name: {
        label: 'Nom de l\'événement',
        hover: 'Le nom de cet événement, par exemple : première exposition de peinture pour enfants'
      },
      cycle: {
        label: 'Cycle de l\'événement',
        hover: 'La durée totale de l\'événement, du début à la fin : Par exemple : 20.01.2024 ~ 20.05.2024 ; si non décidé, veuillez estimer une période'
      },
      stage: {
        title: 'Phase de l\'événement',
        desc: 'Une seule phase peut être créée pour le moment. Pour en ajouter plus, terminez la configuration initiale, puis utilisez "Configuration avancée" dans la liste des événements.',
        name: {
          title: 'Nom de la phase',
          hover: 'Le nom de la phase de l\'événement. Actuellement, une seule phase peut être établie ; par exemple : premier tour ou deuxième tour ou audition ou finale'
        },
        start: {
          title: 'Période d\'inscription',
          hover: 'La date et l\'heure de début et de fin des inscriptions pour cette phase, veuillez être précis jusqu\'à la minute et la seconde. Note : Les inscriptions ne sont pas autorisées en dehors de la période d\'inscription ; si non décidé, vous pouvez le remplir plus tard'
        },
        hold: {
          title: 'Période de tenue',
          hover: 'La date et l\'heure de début et de fin de cette phase, veuillez être précis jusqu\'à la minute et la seconde, par exemple : période d\'exposition en ligne ou période de cérémonie de remise des prix ; si non décidé, vous pouvez le remplir plus tard'
        }
      },
      poster: {
        title: 'Affiche de l\'événement',
        upload: 'Cliquez pour télécharger',
        tips: {
          _1: 'Conseil : Support des formats d\'image .jpg, .png ; la capacité maximale de l\'image ne peut pas dépasser 5MB ; le ratio de taille de l\'image doit être maintenu à 1:1 si possible, et la taille minimale est de 860px*860px',
          _2: 'L\'image sera affichée en haut de la page du candidat, cliquez pour voir la légende'
        }
      },
      detail: {
        desc: 'Visible pour les inscrits, cliquez pour voir la légende',
        placeholder: 'Veuillez saisir',
        title: {
          _1: 'Introduction de l\'événement',
          _2: 'Règles d\'inscription',
          _3: 'Organisation'
        }
      }
    },
    group: {
      title: 'Informations sur le groupe',
      desc: 'Actuellement, un seul événement de groupe peut être établi. Il y a plusieurs événements de groupe différents. Veuillez d\'abord terminer la création initiale de l\'événement, puis cliquez sur "Configuration de l\'événement - Configuration de la sous-compétition" de l\'événement dans la liste des événements pour le configurer. Le système d\'événements permet que différents événements de groupe puissent définir différents frais d\'inscription, formulaires d\'inscription, sélection de base, formulaires d\'inscription et autres paramètres',
      category: {
        title: 'Catégorie',
        hover: 'Exemple : Art ; Danse ;',
        add: 'Ajouter une catégorie',
        name: 'Nom de la catégorie'
      },
      group: {
        title: 'Groupe d\'activité',
        hover: 'Exemple : Groupe jeunesse ; Groupe adulte ;',
        add: 'Ajouter un groupe',
        name: 'Nom du groupe'
      },
      form: {
        title: 'Formulaire d\'inscription',
        hover: 'Le contenu des informations que l\'inscrit doit remplir ; différentes catégories ou groupes peuvent utiliser différents formulaires d\'inscription',
        create: 'Créer les informations d\'inscription à l\'événement'
      },
      charge: {
        title: 'Frais d\'inscription',
        hover: 'Différentes catégories ou groupes peuvent être définis avec des frais différents'
      },
      config: {
        title: 'Paramètres de configuration détaillés :',
        hover: 'Différentes catégories ou groupes peuvent définir différentes règles de sélection, critères de sélection, méthodes de sélection, nombre de sélections, date d\'annonce des résultats de sélection, etc.',
        repeat: {
          title: 'Inscription répétée pour le même groupe :',
          hover: 'Si un événement de groupe permet aux utilisateurs de s\'inscrire plusieurs fois avec les mêmes informations',
          default: 'Fermer'
        },
        pass: {
          title: 'Validation de l\'inscription :',
          hover: 'Après la soumission de l\'inscription par l\'utilisateur, si le système la vérifiera par défaut pour déterminer si l\'inscription est valide/invalide',
          default: 'Validation automatique',
          prepay: 'Vérifier d\'abord, puis payer',
          postpay: 'Payer d\'abord, puis vérifier'
        },
        show: {
          title: 'Affichage au centre d\'inscription :',
          hover: 'Individuel : inscription lors de la saisie des informations d\'une personne ; "Équipe" : une inscription composée des informations de plusieurs personnes, partageant une œuvre',
          default: 'Afficher'
        },
        form: {
          title: 'Formulaire d\'inscription de groupe :',
          hover: 'Individuel : inscription lors de la saisie des informations d\'une personne ; "Équipe" : une inscription composée des informations de plusieurs personnes, partageant une œuvre',
          default: 'Individuel',
          team: 'Équipe',
          min: 'Taille minimale de l\'équipe :',
          max: 'Taille maximale de l\'équipe :'
        },
        base: {
          title: 'Fonction d\'évaluation de base :',
          hover: 'Si la fonction d\'évaluation de base doit être activée ; exemple : Activer ou Fermer',
          default: 'Fermer'
        },
        commission: {
          title: 'Commission du partenaire :',
          hover: 'En tant que canal subordonné de l\'organisateur, le partenaire définit le ratio de commission des frais d\'inscription',
          default: 'Fermer'
        },
        inherit: {
          title: 'Héritage du numéro de sélection :',
          hover: 'Dans la gestion avancée de la sélection dans le menu principal, vous pouvez définir le numéro de sélection des œuvres inscrites, et le numéro peut être hérité au tour suivant lors de l\'avancement',
          default: 'Fermer'
        }
      }
    },
    session: {
      title: 'Informations sur la session',
      desc: 'Conseil : La création de session actuelle est uniquement associée à l\'événement de groupe créé à l\'étape précédente. Plusieurs événements de groupe ont des arrangements de session. Veuillez d\'abord terminer la création initiale de l\'événement, entrer dans la gestion de l\'événement, et cliquer sur "Configuration de l\'événement - Configuration de la sous-compétition - Configuration de la session" pour le configurer. Un seul groupe peut créer plusieurs sessions, et différents groupes peuvent également créer différentes sessions.',
      name: 'Événements de groupe',
      number: {
        title: 'Inscrits',
        hover: 'Les inscrits sont définis pour une seule session. S\'il y a plusieurs sessions, le nombre de participants pour chaque session doit être défini séparément',
        config: 'Paramètres',
        default: 'Illimité'
      },
      arrange: {
        title: 'Arrangements de session',
        hover: 'Si les arrangements de session pertinents n\'ont pas été déterminés, vous pouvez le fermer ; s\'il y a déjà des arrangements de session, vous pouvez l\'ouvrir pour les paramètres, supportant en ligne et hors ligne',
        default: 'Fermer'
      },
      form: 'Format de session :',
      online: 'Adresse en ligne',
      offline: 'Sélection de région',
      address: 'Adresse détaillée',
      time: 'Heure de session'
    }
  }
} 


// WEBPACK FOOTER //
// ./src/langs/fr/activity.js